<form [formGroup]="patientForm" (ngSubmit)="createQuickPatient()" class="p-4 flex flex-col gap-6">

    <div class="grid grid-cols-2 gap-4">
        <app-input label="Nombre" formControlName="firstName" icon="solar:user-bold-duotone"
            [required]="true"></app-input>
        <app-input label="Apellido" formControlName="lastName" icon="solar:user-bold-duotone"
            [required]="true"></app-input>
    </div>

    <div class="grid grid-cols-2 gap-4">
        <app-select label="Tipo ID" formControlName="identificationType" [options]="idTypeOptions"
            icon="mdi:id-card-outline"></app-select>

        <app-input label="Identificación" formControlName="identification" icon="mdi:id-card"></app-input>
    </div>

    <div class="grid grid-cols-2 gap-4">
        <app-input label="Teléfono" formControlName="phone" icon="solar:phone-bold-duotone"
            placeholder="+593..."></app-input>

        <app-input label="F. Nacimiento" formControlName="birthDate" type="date" icon="solar:calendar-bold-duotone"></app-input>
    </div>

    <div class="grid grid-cols-2 gap-4">
        <app-input label="Email" formControlName="email" type="email" icon="solar:letter-bold-duotone"
            placeholder="paciente@ejemplo.com"></app-input>

        <app-select label="Género" formControlName="gender" [options]="gendersOptions" icon="solar:users-group-two-rounded-bold-duotone"></app-select>
    </div>

    <app-input label="Dirección" formControlName="address" icon="solar:map-point-bold-duotone"
        placeholder="Calle, ciudad..."></app-input>

    <div class="flex items-center justify-end gap-3 pt-8 border-t border-foreground/[0.05]">
        <app-button variant="secondary" size="md" (btnClick)="close()" fit="text"
            classList="!text-text-muted !bg-foreground/[0.03]">
            Cancelar
        </app-button>
        <app-button type="submit" size="md" [loading]="loading()" [disabled]="patientForm.invalid"
            iconLeft="solar:user-plus-bold-duotone">
            Crear Paciente
        </app-button>
    </div>
</form>